module.exports = new __parcel__URL__("BrickABrack.93399f38.avif").toString();